import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {createFrom, EventService} from '@spartacus/core';
import {isPlatformBrowser} from '@angular/common';
import {Observable} from 'rxjs';
import {NavigationEvent} from '@spartacus/storefront';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {filter, map} from 'rxjs/operators';
import {CpqConfiguratorPageEvent} from './cpq-configurator-page-event';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class CpqConfiguratorPageEventService {
  constructor(@Inject(PLATFORM_ID) public platformId: string, protected event: EventService) {
    this.register();
  }

  protected register(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.event.register(CpqConfiguratorPageEvent, this.buildConfiguratorPageEvent());
  }

  protected buildConfiguratorPageEvent(): Observable<CpqConfiguratorPageEvent> {
    return this.event.get(NavigationEvent).pipe(
      untilDestroyed(this),
      filter((navigationEvent) => navigationEvent.semanticRoute === 'configureCPQCONFIGURATOR'),
      map((navigationEvent) =>
        createFrom(CpqConfiguratorPageEvent, {
          navigation: navigationEvent,
        })
      )
    );
  }
}
